<div class="modal-header">
    <span class="modal-header-title">{{ 'NOTIFICATION.SETTING_NOTIFICATION' | translate }}</span>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
        <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
    </button>
</div>

<div class="modal-body">

    <form class="form" #f="ngForm" [formGroup]="form" autocomplete="off">

        <div class="row">

            <div class="col-6">
                <label for="legal_form_id"><span class="star">*</span> {{ 'ROLE' | translate }}</label>
                <ng-select 
                    id="permission_id" 
                    class="custom" 
                    clearAllText="{{ 'CLEAR' | translate }}" 
                    notFoundText="{{ 'NO_DATA' | translate }}"
                    bindLabel="name" 
                    bindValue="id" 
                    formControlName="id"
                    placeholder="{{ 'USERS.USERS_ROLES.CHOOSE_ROLE' | translate }}"
                    [loading]="loading" 
                    [items]="uroles">
                 </ng-select>
            </div>

            <div class="col-6">
                <label class="filter-label" for="legal_form_id"><span class="star">*</span> {{ 'NOTIFICATION.TYPE_OF_NOTIFICATION' | translate }}</label>
                <ng-select 
                    id="permission_id" 
                    class="custom" 
                    clearAllText="{{ 'CLEAR' | translate }}" 
                    notFoundText="{{ 'NO_DATA' | translate }}"
                    bindLabel="name" 
                    bindValue="id"
                    [multiple]="true" 
                    [closeOnSelect]="false"
                    formControlName="type"
                    placeholder="{{ 'NOTIFICATION.CHOOSE_TYPE_OF_NOTIFICATION' | translate }}"
                    [loading]="loading" 
                    [items]="types">
                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                        <input id="item-{{index}}" type="checkbox"
                            [checked]="item$.selected" />&nbsp;
                        <span>{{item.name}}</span>
                    </ng-template>
                </ng-select>
                   
                <!-- <div *ngIf="errorMessages">
                    <div *ngFor="let item of errorMessages.notification_type">
                        <div class="text-error" *ngIf="validation(['notifications', i, 'notification_type'], item.type)">
                            {{ item.message | translate: item.options }}
                        </div>
                    </div>
                </div> -->
            </div>

        </div>
    </form>
</div>
<div class="modal-footer btn-box">
    <button *ngIf="!notificationId" type="button" class="btn btn-primary btn-sm" (click)="onCreate()"
        [disabled]="form.invalid">{{ 'SAVE'| translate}}</button>
    <button *ngIf="notificationId" type="button" class="btn btn-primary btn-sm" (click)="onUpdate()"
        [disabled]="form.invalid">{{ 'SAVE'| translate}}</button>
    <button type="button" class="btn btn-light btn-sm" (click)="activeModal.dismiss(false)">
        {{ 'CLOSE' | translate}}
    </button>
</div>